import React from "react";
import { WidgetProps } from "@rjsf/utils";
import { Radio } from "antd";

interface RadioOption {
  value: boolean | string | number;
  label: string;
}

interface EnumOptionsType {
  value: boolean | string | number;
  label: string;
}

const RadioWidget = (props: WidgetProps) => {
  const {
    id,
    value,
    disabled,
    readonly,
    options,
    onChange,
    onBlur,
    onFocus,
  } = props;

  // Use type assertion to access enumOptions with proper typing
  const enumOptions = (options?.enumOptions || []) as EnumOptionsType[];

  const radioOptions: RadioOption[] = enumOptions.map((option) => {
    // If the option is a boolean type or has a boolean value, use Ja/Nee labels
    if (typeof option.value === 'boolean') {
      return {
        value: option.value,
        label: option.value === true ? 'Ja' : 'Nee'
      };
    }
    
    // For non-boolean values, use the original label
    return {
      value: option.value,
      label: option.label
    };
  });

  return (
    <Radio.Group
      id={id}
      name={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onBlur={() => onBlur(id, value)}
      onFocus={() => onFocus(id, value)}
      disabled={disabled || readonly}
    >
      {radioOptions.map((option: RadioOption) => (
        <Radio key={String(option.value)} value={option.value}>
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default RadioWidget;
